export default "__VITE_ASSET__9_hAjG24__"